<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import "static/css/custom-bootstrap.scss";
  @import "static/css/custom-import.scss";
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  @media (min-width: 768px) {
    #app {
      height: 100vh;
      overflow-y: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue